import api from "./api";
import { APIS } from "../endpoints";


export const getAllGenresData = async (limit, page, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.genres}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getGenreData = async (alias) => {
    const endpoint = `${APIS.BASE_URL}${APIS.genres}/${alias}`;

    try {
        const result = await api.get(endpoint);

        // Return the `data` if the result exists, otherwise return an empty array
        return result?.data?.data || [];
    } catch (error) {
        console.error('Error fetching virtual tour data:', error);
        return [];
    }
};

export const updateGenreData = async (alias, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.genres}/${alias}`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const createNewGenre = async (data) => {

    const result = await api.post(`${APIS.BASE_URL}${APIS.genres}`, data)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
}